import { SetPasswordView } from '@/views/SetPasswordView';

const SetPasswordPage = () => <SetPasswordView />;
export default SetPasswordPage;
